<div class="container mt-3">

    <div class="notes-pdf-cards" *ngIf="pdfLinkCards.length > 0">
        <a class="notes-pdf-card" *ngFor="let link of pdfLinkCards" [href]="link.url"
            target="_blank" rel="noopener noreferrer">
            {{ link.label || (link.country ? ('NOTE.COUNTRY_LINK' | translate: { country: link.country }) : ('NOTE.PDF' | translate)) }}
        </a>
    </div>

    <div class="accordion" *ngIf="pdfLinkCards.length === 0">
        <div class="card"
            *ngIf="filteredGeneralNotes.length > 0 || generalPdfLinks.length > 0 || generalConfigPdfLinks.length > 0">
            <div class="card-header" id="headingOne">
                <h2 class="mb-0">
                    <button class="btn btn-link btn-block text-left" type="button" data-toggle="collapse"
                    data-target="#generalNotes" aria-expanded="true" aria-controls="generalNotes">
                    {{ "NOTE.BACKOFFICE" | translate }}
                    </button>
                </h2>
            </div>

            <div id="generalNotes" class="collapse show">
                <div class="card-body">
                    <ng-container *ngFor="let generalNote of filteredGeneralNotes">
                        <ng-container *ngIf="generalNote.type === 'NEWSHEET'">
                            <!-- <h4 *ngIf="generalNote.position === 'HEADER'" class="mb-3">{{ "NOTE.HEADERTITLE" | translate }}</h4>
                            <h4 *ngIf="generalNote.position === 'FOOTER'" class="mt-3 mb-3">{{ "NOTE.FOOTERTITLE" | translate }}</h4> -->
                            <span [innerHTML]="generalNote.text | safeHtml"></span>
                        </ng-container>
                    </ng-container>
                    <ng-container *ngIf="isTravelAgency && filteredStatementNotes.length > 0">
                        <hr>
                        <h4 class="mb-3">{{ "NOTE.STATEMENT" | translate }}</h4>
                        <ng-container *ngFor="let statementNote of filteredStatementNotes">
                            <span [innerHTML]="statementNote.text | safeHtml"></span>
                        </ng-container>
                    </ng-container>
                    <ul class="notes-pdf-links list-unstyled mb-0"
                        *ngIf="generalPdfLinks.length > 0 || generalConfigPdfLinks.length > 0">
                        <li *ngFor="let link of generalPdfLinks">
                            <a [href]="link.url" target="_blank" rel="noopener noreferrer">
                                <i class="fas fa-file-pdf mr-1"></i>{{ link.label || ('NOTE.PDF' | translate) }}
                            </a>
                        </li>
                        <li *ngFor="let link of generalConfigPdfLinks">
                            <a [href]="link.url" target="_blank" rel="noopener noreferrer">
                                <i class="fas fa-file-pdf mr-1"></i>{{ link.label || ('NOTE.PDF' | translate) }}
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        <div class="card" *ngIf="filteredCountryNotes.length > 0 || countryPdfLinks.length > 0">
            <div class="card-header" id="headingOne">
                <h2 class="mb-0">
                    <button class="btn btn-link btn-block text-left" type="button" data-toggle="collapse"
                    data-target="#countryNotes" aria-expanded="true" aria-controls="countryNotes">
                    {{ "NOTE.COUNTRY" | translate }}
                    </button>
                </h2>
            </div>

            <div id="countryNotes" class="collapse show">
                <div class="card-body">
                    <ng-container *ngFor="let countryNote of filteredCountryNotes">
                        <ng-container *ngIf="countryNote.type === 'NEWSHEET'">
                            {{countryNote.countryName}}<br>
                            <span [innerHTML]="countryNote.text | safeHtml"></span>
                        </ng-container>
                    </ng-container>
                    <ul class="notes-pdf-links list-unstyled mb-0" *ngIf="countryPdfLinks.length > 0">
                        <li *ngFor="let link of countryPdfLinks">
                            <a [href]="link.url" target="_blank" rel="noopener noreferrer">
                                <i class="fas fa-file-pdf mr-1"></i>{{ link.label || ('NOTE.PDF' | translate) }}
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        <div class="card" *ngIf="insurancePdfLinks.length > 0">
            <div class="card-header" id="headingInsurance">
                <h2 class="mb-0">
                    <button class="btn btn-link btn-block text-left" type="button" data-toggle="collapse"
                    data-target="#insurancePdf" aria-expanded="true" aria-controls="insurancePdf">
                    {{ "NOTE.INSURANCE" | translate }}
                    </button>
                </h2>
            </div>

            <div id="insurancePdf" class="collapse show">
                <div class="card-body">
                    <ul class="notes-pdf-links list-unstyled mb-0">
                        <li *ngFor="let link of insurancePdfLinks">
                            <a [href]="link.url" target="_blank" rel="noopener noreferrer">
                                <i class="fas fa-file-pdf mr-1"></i>{{ link.label || ('NOTE.PDF' | translate) }}
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        <div class="card" *ngIf="filteredSupplierNotes.length > 0">
            <div class="card-header" id="headingOne">
                <h2 class="mb-0">
                    <button class="btn btn-link btn-block text-left" type="button" data-toggle="collapse"
                    data-target="#supplierNotes" aria-expanded="true" aria-controls="supplierNotes">
                    {{ "NOTE.SUPPLIER" | translate }}
                    </button>
                </h2>
            </div>

            <div id="supplierNotes" class="collapse show">
                <div class="card-body">
                    <ng-container *ngFor="let supplierNote of filteredSupplierNotes">
                        <ng-container *ngIf="supplierNote.type === 'NEWSHEET'">
                            {{supplierNote.supplierName}}<br>
                            {{supplierNote.countryName}}<br>
                            <span [innerHTML]="supplierNote.text | safeHtml"></span>
                        </ng-container>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>
</div>
